import { motion } from "framer-motion";
import { useLanguage } from "../context/LanguageContext";
import { waLink } from "../data/siteConfig";
import { WhatsAppIcon } from "./WhatsAppIcon";

const FloatingWhatsApp = () => {
  const { t } = useLanguage();
  return (
    <motion.a
      href={waLink(t.hero.waMessage)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-button"
      aria-label={t.nav.cta}
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6, delay: 1.4, ease: [0.22, 1, 0.36, 1] }}
      className="whatsapp-pulse fixed bottom-6 end-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-bronze text-white shadow-[0_12px_30px_rgba(184,151,104,0.45)] transition-colors duration-300 hover:bg-bronze-dark"
    >
      <WhatsAppIcon className="h-6 w-6" />
    </motion.a>
  );
};

export default FloatingWhatsApp;
